import { localState } from "../../../Domain/Context";
import { ActionType } from "../../../Domain/HeaderState";

export enum SearchHeaderEvent {
    SHOW_SEARCH_RESULTS = "showResultsPanel",
    HIDE_SEARCH_RESULTS = "hideResultsPanel",
    SHOW_SEARCH_LOADER = "loadingResults",
}

export const globalReducer = function (
    state: localState,
    action: ActionType
): localState {
    switch (action.type) {
        case SearchHeaderEvent.SHOW_SEARCH_RESULTS:
            return {
                ...state,
                foundResults: action.payload,
                showResults: true,
                showLoading: false,
            };
        case SearchHeaderEvent.HIDE_SEARCH_RESULTS:
            return {
                ...state,
                foundResults: [],
                showResults: false,
                showLoading: false,
            };
        case SearchHeaderEvent.SHOW_SEARCH_LOADER:
            return {
                ...state,
                foundResults: [],
                showResults: true,
                showLoading: true,
            };
        default:
            return state;
    }
};
